import * as _usr_const from '../../../config/usr-constant';
import * as _debug from '../../../helper/debug';
import axios from 'axios';

type getMailMagazineGroupsFormParamsProps = {
  unmounted: boolean,
  setFormParams: React.Dispatch<React.SetStateAction<{
    mailFroms: {};
    signatures: {};
  }>>,
  setFormParamsError: React.Dispatch<React.SetStateAction<boolean>>,
  source: any
}
export async function getMailMagazineGroupsFormParams({
  unmounted,
  setFormParams,
  setFormParamsError,
  source
}: getMailMagazineGroupsFormParamsProps) {
  // get data
  await axios
  .get(
    _usr_const.ApiUrl + 'mail-magazine-groups/get-form-params/index.json', {
      cancelToken: source.current.token
    }
  )
  .then((response) => {    
    if (typeof response.data !== 'undefined') {
        if (!unmounted) {
          setFormParams(response.data);
        }
    }
  })
  .catch((error) => {
    _debug.debugAxiosError(error);
    if (!unmounted) { 
      setFormParamsError(true);
    }
  })
  .finally(() => {
    return Promise.resolve(1);
  });
}